import {
  AuthByPasswordBodyType,
  AuthByPasswordResponseType
} from "@website/widget/login/services/auth-by-password/auth-by-password.types";
import { BASE_URL_PROFILE } from "@website/widget/login/services/urls";
import { Axios } from "@website/widget/login/utils";
import { AxiosResponse } from "axios";

export const AuthByPasswordUrl = `${BASE_URL_PROFILE}/auth/password`;

export const AuthByPasswordService = (
  body: AuthByPasswordBodyType
): Promise<AuthByPasswordResponseType> =>
  Axios.post(AuthByPasswordUrl, body).then(
    ({ data }: AxiosResponse<AuthByPasswordResponseType>) => data
  );
